<template>
  <a @click="searchRoute" class="button-primary mx-2 py-1 rounded block">
    {{ $t('tour_plan_find_route') }}
  </a>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from '../../constants'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo');

export default {
  props: {
    route: {
      type: Object,
      required: false
    }
  },
  methods: {
    searchRoute: function () {
      const from = this.route.points[0]
      const to = this.route.points[this.route.points.length - 1]
      // RTWebへのリンク
      const areaId = this.$store.getters['user/getAreaId']
      var url = Constants.REAL_TIME_SEARCH_WEB + "?serviceid=" + areaId + "&utm_source=" + this.convertAreaId(areaId) + "&utm_medium=referral&utm_campaign=" + this.convertAreaId(areaId)
      if (this.route.index === 0) {
        url += "&frompoi=" + encodeURIComponent(this.departure.name)
        url += "&fromcode=" + this.departure.code
      } else {
        url += "&frompoi=" + encodeURIComponent(from.name)
        url += "&fromlatitude=" + from.location.latitude + "&fromlongitude=" + from.location.longitude
      }
      if (this.route.index === this.destinations.length) {
        url += "&topoi=" + encodeURIComponent(this.arrival.name)
        url += "&tocode=" + this.arrival.code
      } else {
        url += "&topoi=" + encodeURIComponent(to.name)
        url += "&tolatitude=" + to.location.latitude + "&tolongitude=" + to.location.longitude
      }
      url += "&date=" + from.departureTime.format('YYYYMMDD')
      url += "&time=" + from.departureTime.format('HHmm')
      window.open(url)
    },
    convertAreaId:function (areaId) {
      switch (areaId) {
        case "hitachinokunikiko":
          return 'mito'
        case "izunavi":
          return 'izu'
        case 'vin-de-yamanashi':
          return 'katsunuma'
        case 'nasu-ways':
          return 'nasu'
        case 'eeeechoshi':
          return 'choshi'
        case 'marugotowakashio-maas':
          return 'wakashio'
        default:
          return 'JR'
      }
    }
  },
  computed: {
    ...mapGetters({
      departure: 'destinations/getDepatureStation',
      arrival: 'destinations/getArrivalStation',
      destinations: 'destinations/getAll'
    })
  }
}
</script>